
import "./functions";

export default {


    init() {

    },



}